import React from 'react';
import { CSSTransition } from 'react-transition-group';
import styles from './Confirm.module.css';
import animStyles from 'ui/animation/animation.module.css';

export default class Confirm extends React.Component {
  static getDerivedStateFromProps(props, state) {
    const { location } = props;
    const { prevLocation, hideResolve } = state;

    if (
      !(
        prevLocation &&
        prevLocation.pathname === location.pathname &&
        prevLocation.search === location.search
      )
    ) {
      if (hideResolve) {
        hideResolve({ cancel: true });
      }

      return {
        prevLocation: location,
        hideResolve: null,
      };
    }

    return null;
  }

  state = {
    options: {},
    prevLocation: null,
    hideResolve: null,
  };

  show(options = {}) {
    if (this.state.hideResolve) {
      this.state.hideResolve({ cancel: true });
    }

    return new Promise(resolve => {
      this.setState({ hideResolve: resolve, options });
    });
  }

  hide(options) {
    if (this.state.hideResolve) {
      this.state.hideResolve(options);

      this.setState({ hideResolve: null });
    }
  }

  handleDone = () => {
    this.hide({ done: true });
  };

  handleCancel = () => {
    const { options } = this.state;
    const { cancelable = true } = options;

    if (!cancelable) {
      return;
    }

    this.hide({ cancel: true });
  };

  renderContent() {
    const { options } = this.state;
    const {
      message = '',
      title = '',
      cancelTitle = '取消',
      doneTitle = '确定',
      primary = 'done',
      cancelable = true,
      succIcon = false,
    } = options;
    let leftButton, rightButton;

    if (cancelable) {
      if (primary === 'cancel') {
        leftButton = (
          <span className={styles.cancelBtn} onClick={this.handleDone}>
            {doneTitle}
          </span>
        );
        rightButton = (
          <span className={styles.doneBtn} onClick={this.handleCancel}>
            {cancelTitle}
          </span>
        );
      } else {
        leftButton = (
          <span className={styles.cancelBtn} onClick={this.handleCancel}>
            {cancelTitle}
          </span>
        );
        rightButton = (
          <span className={styles.doneBtn} onClick={this.handleDone}>
            {doneTitle}
          </span>
        );
      }
    } else {
      rightButton = (
        <span className={styles.doneBtn} onClick={this.handleDone}>
          {doneTitle}
        </span>
      );
    }

    return (
      <React.Fragment>
        <div className={styles.content}>
          {title ? (
            <React.Fragment>
              <div className={styles.title}>{title}</div>
              {succIcon && (
                <div className={styles.succIconBox}>
                  <span className={styles.succIcon}></span>
                </div>
              )}

              <div className={styles.message2}>{message}</div>
            </React.Fragment>
          ) : (
            <div className={styles.message}>{message}</div>
          )}
        </div>
        <div className={styles.bar}>
          {cancelable ? (
            <React.Fragment>
              <div className={styles.barItem}>{leftButton}</div>
              <div className={styles.barItem}>{rightButton}</div>
            </React.Fragment>
          ) : (
            <div className={styles.barItem}>{rightButton}</div>
          )}
        </div>
      </React.Fragment>
    );
  }

  render() {
    const { hideResolve } = this.state;

    return (
      <CSSTransition
        in={!!hideResolve}
        timeout={200}
        classNames={{
          enter: animStyles.fadeInEnter,
          enterActive: animStyles.fadeInEnterActive,
          exit: animStyles.fadeInExit,
          exitActive: animStyles.fadeInExitActive,
          exitDone: animStyles.fadeInExitDone,
        }}
        mountOnEnter
      >
        <div className={styles.alertWrapper}>
          <span
            className={animStyles.transparentMask}
            onClick={this.handleCancel}
          />
          <div className={animStyles.centerModal}>
            <div className={styles.alertContent}>{this.renderContent()}</div>
          </div>
        </div>
      </CSSTransition>
    );
  }
}
